<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          تیکت‌ها
        </CCardHeader>
        <CCardBody class="d-flex align-items-center text-center h-100">
          <CDataTable
              class="
              w-100
              d-flex
              flex-column
              justify-content-between
              align-items-end
              h-100
            "
              :noItemsView="{
              noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
            }"
              :items="computedTicket"
              :fields="fields"
              hover
              striped
              border
              small
              fixed
              :loading="loading"
          >
            <template #removeTicket="{ item }">
              <td>
                <CButton
                    :disabled="loading"
                    size="md"
                    @click="onRemoveTicketModal(item)"
                >
                  <CIcon name="cil-trash"/>
                </CButton>
              </td>
            </template>
            <!--            <template #viewTicket="{ item }">-->
            <!--              <td>-->
            <!--                <CButton-->
            <!--                    v-if="item.response"-->
            <!--                    :disabled="loading"-->
            <!--                    square-->
            <!--                    size="sm"-->
            <!--                    class="modal-button px-3 py-1"-->
            <!--                    @click="onViewTicketAnswerModal(item)"-->
            <!--                >-->
            <!--                  مشاهده-->
            <!--                </CButton>-->
            <!--              </td>-->
            <!--            </template>-->
            <template #addAnswer="{ item }">
              <td>
                <CButton
                    v-if="item.response === null"
                    color="success"
                    :disabled="loading"
                    square
                    size="md"
                    class="px-4 py-1"
                    @click="onAddTicketAnswerModal(item)"
                >
                  ثبت
                </CButton>
                <CButton
                    v-else
                    :disabled="loading"
                    square
                    size="sm"
                    class="modal-button px-3 py-1"
                    @click="onAddTicketAnswerModal(item)"
                >
                  ویرایش
                </CButton>
              </td>
            </template>
          </CDataTable>
          <AddTicketAnswerModal v-model="addTicketAnswerModal" :ticket="selectedItem" @get-ticket="getTicket"/>
          <!--          <ViewTicketAnswerModal v-model="viewTicketAnswerModal" :ticket="selectedItem"/>-->
          <RemoveTicketModal v-model="removeTicketModal" :ticket="selectedItem" @get-ticket="getTicket"/>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "@/plugins/axios";
import ViewTicketAnswerModal from "@/components/Modals/Ticket/ViewTicketAnswerModal.vue";
import RemoveTicketModal from "@/components/Modals/Ticket/RemoveTicketModal";
import AddTicketAnswerModal from "@/components/Modals/Ticket/AddTicketAnswerModal";

export default {
  components: {
    AddTicketAnswerModal,
    RemoveTicketModal,
    ViewTicketAnswerModal,
  },
  name: "Ticket",
  data() {
    return {
      ticket: [],
      loading: false,
      fields: [
        {key: "title", label: "موضوع"},
        {key: "computedStudent", label: "دانش آموز"},
        {key: "computedDate", label: "تاریخ ارسال"},
        {key: "computedResponseDate", label: "تاریخ دریافت پاسخ"},
        {key: "addAnswer", label: "پاسخ"},
        {key: "removeTicket", label: "حذف"},
      ],
      selectedItem: null,
      removeTicketModal: false,
      viewTicketAnswerModal: false,
      addTicketAnswerModal: false,
    };
  },
  computed: {
    computedTicket() {
      return this.ticket.map((item) => {
        return {
          ...item,
          computedStudent: `${item.student.name} ${item.student.lastname}`,
          computedDate: item.addDate.replaceAll("-", "/"),
          computedResponseDate: item.responseDate ? item.responseDate.replaceAll("-", "/") : '',
        };
      });
    },
  },
  mounted() {
    this.getTicket();
  },
  methods: {
    async getTicket() {
      try {
        this.loading = true;
        const {data} = await axios.get("/ticket");
        this.ticket = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    onAddTicketAnswerModal(item) {
      this.selectedItem = item;
      this.addTicketAnswerModal = true;
    },
    onViewTicketAnswerModal(item) {
      this.selectedItem = item;
      this.viewTicketAnswerModal = true;
    },
    onRemoveTicketModal(item) {
      this.selectedItem = item;
      this.removeTicketModal = true;
    }
  },
};
</script>

<style lang="scss" scoped></style>